import React, {useCallback, useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {v4 as uuidv4} from 'uuid';
import IconSelector from '@ibibo/icon-selector';
import {userSelector, fetchUserDetails, logout} from '@ibibo/user-reducer';

import * as S from './Header.styles';

import {
  HOTELS_HOME_URL_NEW,
  HOTELS_HOME_URL_OLD,
  showOldHeaderUrlList,
} from '../../../verticals/onboarding/src/constants/index';

const HeaderWrapper = () => {
  const dispatch = useDispatch();
  const host = `${__ENV_CONFIG__.AGENTPROXY_HOST}`;

  let crId = null;

  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    crId = params.get('crId');
  }

  const accountDetails = useSelector(userSelector);
  const [showVertical, setShowVertical] = useState(false);

  const [tabActive, setTabActive] = useState(9);
  const [showFlightHover, setShowFlightHover] = useState(false);
  const [showHotelsHover, setShowHotelsHover] = useState(false);
  const [showHolidayHover, setShowHolidayHover] = useState(false);
  const [showInsuranceHover, setShowInsuranceHover] = useState(false);
  const [showVisaHover, setShowVisaHover] = useState(false);
  const [vandeUser, setVandeUser] = useState(false);

  const [showHeader, setShowHeader] = useState(false);
  const [showHeaderList, setShowHeaderList] = useState(false);

  const {isLoading, isLoggedIn, userInfo, walletInfo, vandeBharat} = accountDetails;

  useEffect(() => {
    setVandeUser(vandeBharat?.user_enabled);
  }, [vandeBharat]);

  const fetchUserDetailsCaller = useCallback(() => {
    return dispatch(fetchUserDetails());
  }, [dispatch]);

  const logoutUserCaller = useCallback(() => {
    return dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
    checkLogin();
    fetchUserDetailsCaller();
  }, []);

  useEffect(() => {
    checkLogin();
  }, [isLoggedIn]);

  const checkLogin = () => {
    if (!isLoading && !isLoggedIn) {
      toLogin();
    }
  };

  const getCookie = cname => {
    // Region migrated to India: always report IN regardless of any ccde=AE cookie
    if (cname === 'ccde') return 'IN';
    if (typeof document !== 'undefined') {
      const name = cname + '=';
      const ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
    }
    return '';
  };

  useEffect(() => {
    const flightShow = getCookie('mpsf');
    if (flightShow === '1') {
      setShowVertical(true);
    }
  }, []);

  const toMySettings = () => {
    if (crId) {
      window.open(`/mysettings?crId=${crId}`, '_self');
    } else {
      window.open(`/mysettings?crId=${uuidv4()}`, '_self');
    }
  };

  const toMywallet = () => {
    if (crId) {
      window.open(`/coreui/wallet?crId=${crId}`, '_self');
    } else {
      window.open(`/coreui/wallet?crId=${uuidv4()}`, '_self');
    }
  };

  const redirectToClickedUrlPlatform = redirectUrl => {
    window.open(`${redirectUrl}?crId=${crId ? crId : uuidv4()}`, '_self');
  };

  const toHotelsHome = () => {
    window.open('https://www.makemytrip.com/hotels/', '_self');
  };

  const toLogin = () => {
    window.open('/agent/login/', '_self');
  };

  const logoutUser = () => {
    logoutUserCaller();
  };
  const toMyBookings = () => {
    setShowSelectopt(true);
  };

  const closeSelectBkng = () => {
    setShowSelectopt(false);
  };

  const toOldMyBookings = () => {
    window.open('/mytrips/', '_self');
  };

  const toNewMyBookings = () => {
    window.open('https://mypartner.makemytrip.com/coreui/mybookings/', '_self');
  };

  const toFlightsHome = () => {
    const flightRedirectUrl = getCookie('myPartner_b2b_homepage');
    if (flightRedirectUrl === '1' && window.screen.width > 1024) {
      window.open('https://mypartner.makemytrip.com/landing/flights', '_self');
    } else window.open('https://www.makemytrip.com/flights/', '_self');
  };

  const handleSelect = index => {
    setTabActive(index);
    if (index === 0) {
      const flightRedirectUrl = getCookie('myPartner_b2b_homepage');
      if (flightRedirectUrl === '1' && window.screen.width > 1024) {
        window.open('https://mypartner.makemytrip.com/landing/flights', '_self');
      } else window.open('https://www.makemytrip.com/flights/', '_self');
    } else if (index === 1) {
      toHotelsHome();
    } else if (index === 2) {
      window.open(
        'https://mypartner.makemytrip.com/coreui/europamundo',
        '_self',
      );
    } else if (index === 3) {
      window.open(`https://mypartner.makemytrip.com/insurance/`, '_self');
    } else if (index === 4) {
      window.open('https://mypartner.makemytrip.com/visa/', '_self');
    }
  };

  const toReport = () => {
    if (crId) {
      window.open(`/agent/transactionreport?crId=${crId}`, '_self');
    } else {
      window.open(`/agent/transactionreport?crId=${uuidv4()}`, '_self');
    }
  };

  const [
    {company_name, first_name, last_name, email, whitelabel_logo_image_url, abepoch, navPopList},
    setUserInfo,
  ] = useState({
    company_name: userInfo.company_name ? userInfo.company_name.value : '',
    first_name: userInfo.first_name ? userInfo.first_name.value : '',
    last_name: userInfo.last_name ? userInfo.last_name.value : '',
    email: userInfo.email ? userInfo.email.value : '',
    whitelabel_logo_image_url: userInfo.whitelabel_logo_image_url
      ? userInfo.whitelabel_logo_image_url.value
      : '',
    abepoch: '',
    navPopList: userInfo?.navPopList || [],
  });

  function cookieExists(name) {
    if (typeof document !== 'undefined') {
      var dc = document.cookie;
      var prefix = name + '=';
      var begin = dc.indexOf('; ' + prefix);
      if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
      } else {
        begin += 2;
        var end = document.cookie.indexOf(';', begin);
        if (end == -1) {
          end = dc.length;
        }
      }
      // because unescape has been deprecated, replaced with decodeURI
      //return unescape(dc.substring(begin + prefix.length, end));
      return decodeURI(dc.substring(begin + prefix.length, end));
    }
  }

  const [showSelectOpt, setShowSelectopt] = useState(false);

  const ccdeCookie = getCookie('ccde');
  const supplierEnabled = cookieExists('supplier') ? true : false;

  useEffect(() => {
    setUserInfo({
      company_name: userInfo.company_name ? userInfo.company_name.value : company_name,
      first_name: userInfo.first_name ? userInfo.first_name.value : first_name,
      last_name: userInfo.last_name ? userInfo.last_name.value : last_name,
      email: userInfo.email ? userInfo.email.value : email,
      whitelabel_logo_image_url: userInfo.whitelabel_logo_image_url
        ? userInfo.whitelabel_logo_image_url.value
        : whitelabel_logo_image_url,
      abepoch: userInfo.abepoch ? epochToJsDate(parseInt(userInfo.abepoch.value)) : '',
      navPopList: userInfo?.navPopList || [],
    });
  }, [userInfo]);

  const {tb = 0, wb = 0, pb = 0} = walletInfo;

  let aadharStatus = '';
  if (accountDetails.userInfo.aadhar_number) {
    aadharStatus = accountDetails.userInfo.aadhar_number.status;
  }

  let statusText = '';
  switch (aadharStatus) {
    case 'provide':
      statusText = 'Incomplete';
      break;
    case 'pending':
      statusText = 'Pending';
      break;
    case 'verified':
      statusText = 'Verified';
      break;
    default:
      statusText = '';
  }

  const getOrdinalNum = n => {
    return (
      n + (n > 0 ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10] : '')
    );
  };

  const epochToJsDate = ts => {
    var d = new Date(ts * 1000);
    const dateList = d.toString().split(' ');
    return getOrdinalNum(dateList[2]) + ' ' + dateList[1] + ' ' + dateList[3];
  };

  function getFirstAndLastLetters(sentence) {
    const words = sentence.split(' ');
    const firstLetter = words[0][0] || '';
    if (words.length === 1) {
      return String(firstLetter).toLocaleUpperCase();
    }
    const lastWord: string = words[1];
    const lastLetter: string = lastWord[0] || '';
    const finalString: string = String(firstLetter + lastLetter).toLocaleUpperCase();
    return finalString;
  }

  // let winLoc = window.location.pathname;
  // useEffect(() => {
  //   if(showOldHeaderUrlList.includes(winLoc)) {
  //     setShowHeader(false);
  //   } else if(!showVertical){
  //     setShowHeader(false);
  //   } else{
  //     setShowHeader(true);
  //   }
  // },[winLoc, showVertical]);

  return (
    <>
      <S.HeaderOuterWrap headCheck={showHeader}>
        <S.HeaderInnerWrap>
          <S.LogoVerticalOuterWrap>
            <S.LogoWrapper
              onClick={showVertical ? toFlightsHome : toHotelsHome}
              headCheck={showHeader}
            >
              {/* <IconSelector iconKey="partnerlogo" props={{width: '13.5rem', height: '3.7rem'}} /> */}
              <div className="component-with-coach-mark-wrapper">
                <a className="whiteLabelLogo">
                  {whitelabel_logo_image_url ? (
                    <img className="whiteLabelLogoImg" src={whitelabel_logo_image_url} alt="logo" />
                  ) : (
                    <p className="whiteLabelLogoInitialText">
                      {getFirstAndLastLetters(company_name) || ''}
                    </p>
                  )}
                </a>
                {
                  <p
                    className={`whiteLabelLogoText ${
                      company_name.length > 20 ? 'font12' : 'font16'
                    } primaryTxtWhite appendLeft5 blueTxt appendRight10`}
                  >
                    {company_name || `${last_name}`}
                  </p>
                }
              </div>
            </S.LogoWrapper>
            <S.VerticalIconWrap>
              <S.VerticalIconList>
                <li
                  onClick={() => handleSelect(0)}
                  onMouseEnter={() =>
                    tabActive === 0 ? setShowFlightHover(false) : setShowFlightHover(true)
                  }
                  onMouseLeave={() =>
                    tabActive === 0 ? setShowFlightHover(true) : setShowFlightHover(false)
                  }
                >
                  <IconSelector
                    iconKey={tabActive === 0 || showFlightHover ? 'flightactivehead' : 'flighthead'}
                    props={{width: '3.3rem', height: '3.3rem', margin: '0 0 3px'}}
                  />
                  <p>Flights</p>
                </li>
                {(!vandeUser && ccdeCookie !== 'AE' && (
                  <li
                    onClick={() => handleSelect(1)}
                    onMouseEnter={() =>
                      tabActive === 1 ? setShowHotelsHover(false) : setShowHotelsHover(true)
                    }
                    onMouseLeave={() =>
                      tabActive === 1 ? setShowHotelsHover(true) : setShowHotelsHover(false)
                    }
                  >
                    <IconSelector
                      iconKey={tabActive === 1 || showHotelsHover ? 'hotelactivehead' : 'hotelhead'}
                      props={{
                        width: '3.3rem',
                        height: '3.3rem',
                        margin: '3px 0 0',
                        className: 'svgImageFit',
                      }}
                    />
                    <p>Hotels</p>
                  </li>
                )) ||
                  null}
                <li
                  onClick={() => handleSelect(2)}
                  onMouseEnter={() =>
                    tabActive === 2 ? setShowHolidayHover(false) : setShowHolidayHover(true)
                  }
                  onMouseLeave={() =>
                    tabActive === 2 ? setShowHolidayHover(true) : setShowHolidayHover(false)
                  }
                >
                  <IconSelector
                    iconKey={tabActive === 2 || showHolidayHover ? 'holidayactive' : 'holiday'}
                    props={{
                      width: '3.3rem',
                      height: '3.3rem',
                      margin: '3px 0 0',
                      className: 'svgImageFit',
                    }}
                  />
                  <p>Europamundo</p>
                </li>
                <li
                  onClick={() => handleSelect(3)}
                  onMouseEnter={() =>
                    tabActive === 3 ? setShowInsuranceHover(false) : setShowInsuranceHover(true)
                  }
                  onMouseLeave={() =>
                    tabActive === 3 ? setShowInsuranceHover(true) : setShowInsuranceHover(false)
                  }
                >
                  <IconSelector
                    iconKey={
                      tabActive === 3 || showInsuranceHover
                        ? 'travelinsuranceactive'
                        : 'travelinsurance'
                    }
                    props={{
                      width: '3.3rem',
                      height: '3.3rem',
                      margin: '3px 0 0',
                      className: 'svgImageFit',
                    }}
                  />
                  <p style={{textAlign: 'center'}}>Travel Insurance</p>
                </li>
                {/* <li
                  onClick={() => handleSelect(4)}
                  onMouseEnter={() =>
                    tabActive === 4 ? setShowVisaHover(false) : setShowVisaHover(true)
                  }
                  onMouseLeave={() =>
                    tabActive === 4 ? setShowVisaHover(true) : setShowVisaHover(false)
                  }
                >
                  <IconSelector
                    iconKey={tabActive === 4 || showVisaHover ? 'visaactive' : 'visa'}
                    props={{
                      width: '3.3rem',
                      height: '3.3rem',
                      margin: '3px 0 0',
                      className: 'svgImageFit',
                    }}
                  />
                  <p>Visa</p>
                </li> */}
              </S.VerticalIconList>
            </S.VerticalIconWrap>
          </S.LogoVerticalOuterWrap>

          <S.UserInfoWrap headCheck={showHeader}>
            {ccdeCookie !== 'AE' ? (
              <div>
                <S.UserOptionWrapNew onClick={toReport}>
                  <S.UserOptionIconWrap>
                    <IconSelector iconKey="reportHeadIcon" />
                  </S.UserOptionIconWrap>
                  <S.UserOptionTextWrap>
                    <S.UserOptionHeadTextNew>
                      Transactional <br />
                      Report
                    </S.UserOptionHeadTextNew>
                    {/* <S.UserOptionSubText>Requests</S.UserOptionSubText> */}
                  </S.UserOptionTextWrap>
                </S.UserOptionWrapNew>
              </div>
            ) : (
              <div></div>
            )}
            {ccdeCookie !== 'AE' ? (
              <div>
                <S.UserOptionWrapNew onClick={toNewMyBookings}>
                  <S.UserOptionIconWrap>
                    <IconSelector iconKey="tripshead" />
                  </S.UserOptionIconWrap>
                  <S.UserOptionTextWrap>
                    <S.UserOptionHeadTextNew>My Trips</S.UserOptionHeadTextNew>
                    {/* <S.UserOptionSubText><IconSelector iconKey='rupee' props={{width:'0.7rem', height:'0.7rem', fill: '#c2c2c2'}} />{!isLoading && wb.toLocaleString('en-IN')}</S.UserOptionSubText> */}
                  </S.UserOptionTextWrap>
                </S.UserOptionWrapNew>
              </div>
            ) : (
              <div></div>
            )}
            {(!vandeUser && (
              <S.UserOptionWrapNew onClick={toMywallet}>
                <S.UserOptionIconWrap>
                  {ccdeCookie !== 'AE' ? (
                    <IconSelector iconKey="rewardbonushead" />
                  ) : (
                    <img
                      src={'https://assets-gos3.goibibo.com/myp_PromoCashAED_1-1676986205.png'}
                      alt="promocash"
                    />
                  )}
                </S.UserOptionIconWrap>
                <S.UserOptionTextWrap>
                  <S.UserOptionHeadTextNew>Promo Cash</S.UserOptionHeadTextNew>
                  <S.UserOptionSubText>
                    {ccdeCookie !== 'AE' ? (
                      <IconSelector
                        iconKey="rupee"
                        props={{width: '0.7rem', height: '0.7rem', fill: '#4a4a4a'}}
                      />
                    ) : (
                      <S.AedText props={{width: '0.7rem', height: '0.7rem', fill: '#4a4a4a'}}>
                        AED{' '}
                      </S.AedText>
                    )}
                    {!isLoading && pb.toLocaleString('en-IN')}
                  </S.UserOptionSubText>
                </S.UserOptionTextWrap>
              </S.UserOptionWrapNew>
            )) ||
              null}
            {(!vandeUser && (
              <S.UserOptionWrapNew onClick={toMywallet}>
                {ccdeCookie !== 'AE' ? (
                  <S.UserOptionIconWrap>
                    <IconSelector iconKey="mycashhead" />
                  </S.UserOptionIconWrap>
                ) : (
                  <img
                    src={'https://assets-gos3.goibibo.com/myp_MyCash_AED-1678258698.png'}
                    alt="mycash"
                  />
                )}
                <S.UserOptionTextWrap>
                  <S.UserOptionHeadTextNew>My Cash</S.UserOptionHeadTextNew>
                  <S.UserOptionSubText>
                    {ccdeCookie !== 'AE' ? (
                      <IconSelector
                        iconKey="rupee"
                        props={{width: '0.7rem', height: '0.7rem', fill: '#4a4a4a'}}
                      />
                    ) : (
                      <S.AedText props={{width: '0.7rem', height: '0.7rem', fill: '#4a4a4a'}}>
                        &nbsp; AED{' '}
                      </S.AedText>
                    )}
                    {!isLoading && wb.toLocaleString('en-IN')}
                  </S.UserOptionSubText>
                </S.UserOptionTextWrap>
              </S.UserOptionWrapNew>
            )) ||
              null}
            <S.UserOptionProfileWrap headCheck={showHeader}>
              <S.UserProfileIconWrap>
                <S.ImageCirle>{first_name.slice(0, 1)}</S.ImageCirle>
                <S.NotifiyCircle bgColor={aadharStatus} />
              </S.UserProfileIconWrap>
              <S.UserProfileTextWrap>
                <S.NameTextWrap>
                  <S.UserNameHeadTextNew>
                    Hey {company_name || `${first_name} ${last_name}`}{' '}
                  </S.UserNameHeadTextNew>
                </S.NameTextWrap>
                {/* <IconSelector iconKey="arrowdown" props={{fill: '#008cff', width: '0.8rem', height:'0.4rem', display: 'inline-flex'}}/> */}
              </S.UserProfileTextWrap>
              <S.UserProfileMoreInfoWrap>
                <IconSelector
                  iconKey="arrowdown"
                  props={{width: '0.8rem', height: '0.8rem', fill: '#000'}}
                />
              </S.UserProfileMoreInfoWrap>
              {
                <S.UserMoreInfoWrap>
                  <S.UserMoreInfoInnerWrap>
                    <li onClick={toMySettings}>
                      <S.MenuIconWrap>
                        <IconSelector iconKey="profilehead" />
                      </S.MenuIconWrap>
                      <S.MenuInfoWrap>
                        <S.ProfileHeadWrap>
                          <S.MenuHeading>My Profile</S.MenuHeading>
                          <S.ProfileStatus bgColor={aadharStatus} color={aadharStatus}>
                            {statusText}
                          </S.ProfileStatus>
                        </S.ProfileHeadWrap>
                        <S.MenuSubHeading>
                          Edit Your Profile Setting, Contact Settings and Business Settings
                        </S.MenuSubHeading>
                      </S.MenuInfoWrap>
                    </li>
                    <li
                      onClick={() => {
                        // if (!abepoch) {
                        //   toOldMyBookings();
                        // } else {
                        //   toMyBookings();
                        // }
                        toNewMyBookings();
                      }}
                    >
                      <S.MenuIconWrap>
                        <IconSelector iconKey="bookinghead" />
                      </S.MenuIconWrap>
                      <S.MenuInfoWrap>
                        <S.MenuHeading>My Bookings</S.MenuHeading>
                        <S.MenuSubHeading>
                          See booking details, Print e-ticket, Cancel Booking, Modify Booking, Check
                          Refund Status & More.
                        </S.MenuSubHeading>
                      </S.MenuInfoWrap>
                    </li>
                    {(!vandeUser && (
                      <li onClick={toMywallet}>
                        <S.MenuIconWrap>
                          <IconSelector iconKey="moneyhead" />
                        </S.MenuIconWrap>
                        <S.MenuInfoWrap>
                          <S.MenuHeading>My Wallet</S.MenuHeading>
                          <S.MenuSubHeading>
                            Use your wallet money to avail even greater discounts
                          </S.MenuSubHeading>
                        </S.MenuInfoWrap>
                      </li>
                    )) ||
                      null}
                    {/* {supplierEnabled ? (
                      <li onClick={toSupplierProfie}>
                        <S.MenuIconWrap className="minHeight">
                          <span className="aiSprite nameUploadIcon" />
                        </S.MenuIconWrap>
                        <S.MenuInfoWrap>
                          <S.MenuHeading>Supplier Profile</S.MenuHeading>
                        </S.MenuInfoWrap>
                      </li>
                    ) : (
                      <></>
                    )} */}
                    {/* {supplierEnabled && (
                      <li onClick={toSupplierPlatform}>
                        <S.MenuIconWrap>
                          <IconSelector iconKey="bookinghead" />
                        </S.MenuIconWrap>
                        <S.MenuInfoWrap>
                          <S.MenuHeading>Supplier Platform</S.MenuHeading>
                        </S.MenuInfoWrap>
                      </li>
                    )} */}

                    {navPopList?.length > 0 &&
                      navPopList.map((item, index) => {
                        return (
                          <li
                            onClick={() => redirectToClickedUrlPlatform(item?.redirectUrl)}
                            key={index}
                          >
                            <S.NavPopList>
                              <span className={item?.iconKey} style={item?.customStyle} />
                            </S.NavPopList>
                            <S.MenuInfoWrap>
                              <S.MenuInfoWrap>
                                <S.MenuHeading>{item?.heading}</S.MenuHeading>
                              </S.MenuInfoWrap>
                              <S.MenuSubHeading>{item?.subHeading}</S.MenuSubHeading>
                            </S.MenuInfoWrap>
                          </li>
                        );
                      })}
                    <li onClick={logoutUser}>
                      <S.NavPopList>
                        <IconSelector iconKey="logouthead" />
                      </S.NavPopList>
                      <S.MenuInfoWrap>
                        <S.MenuHeading>Logout</S.MenuHeading>
                      </S.MenuInfoWrap>
                    </li>
                  </S.UserMoreInfoInnerWrap>
                </S.UserMoreInfoWrap>
              }
            </S.UserOptionProfileWrap>
          </S.UserInfoWrap>
        </S.HeaderInnerWrap>
        {(showSelectOpt && abepoch && (
          <>
            <S.BkngSlctBackOverlay onClick={closeSelectBkng} />
            <S.BkngSelectOverlay>
              <S.BkngSelectWrap>
                <S.BkngSelectText>For bookings made before {abepoch}</S.BkngSelectText>
                <S.BkngSelectBtn onClick={toOldMyBookings}>Click Here</S.BkngSelectBtn>
              </S.BkngSelectWrap>
              <S.BkngSelectWrap>
                <S.BkngSelectText>For bookings made on & after {abepoch}</S.BkngSelectText>
                <S.BkngSelectBtn onClick={toNewMyBookings}>Click Here</S.BkngSelectBtn>
              </S.BkngSelectWrap>
            </S.BkngSelectOverlay>
          </>
        )) ||
          null}
      </S.HeaderOuterWrap>
    </>
  );
};

export default HeaderWrapper;
